export const initialReturnHub = {
  name: '',
  address: {
    isBusiness: false,
    countryCode: '',
    postalCode: '',
    city: '',
    street: '',
    houseNumber: '',
    houseNumberSuffix: '',
  },
}
